import Typography from "@mui/material/Typography";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import { AppointmentNotification } from "services/types/notifications";

const AppointmentNotificationComponent = ({
  title,
  description,
}: AppointmentNotification) => {
  return (
    <ListItemText
      primary={title}
      secondary={<Typography>{description}</Typography>}
    />
  );
};

export default AppointmentNotificationComponent;
